import styles from "./TagChart.module.scss";

type TagChartProps = {
  mainValue: string;
  label?: string;
  color?: string;
};

export default function TagChart({
  mainValue,
  label,
  color = "hsl(267, 76%, 43%)",
}: TagChartProps) {
  return (
    <div
      className={styles.tagChartContainer}
      style={{
        color: color,
        border: `2px solid ${color}`,
      }}
    >
      <div className={styles.mainValue}>{mainValue}</div>
      {label && <div className={styles.label}>{label}</div>}
    </div>
  );
}
